module.exports = __webpack_public_path__ + "img/bg-image.a153efc.jpg";